// extracted by mini-css-extract-plugin
export default {"related_container":"related_container__0c03e086","related_item":"related_item__0c03e086"};